import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePromocion } from '../../shared/components';

export type CreatePromocionPageProps = {};

const CreatePromocionPage: React.FC<CreatePromocionPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_promocion);

  return <SavePromocion titlePage="Crear Promoción" />;
};

export default CreatePromocionPage;
